
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.875 0c.305 0 .568.111.791.334.223.223.334.486.334.791v15.75c0 .305-.111.568-.334.791a1.081 1.081 0 0 1-.791.334h-4.5v-6.996h2.25l.378-2.593h-2.628V6.372c0-.375.095-.662.286-.861.19-.2.47-.3.839-.3h1.688V2.875a11.727 11.727 0 0 0-1.846-.123c-1.207 0-2.129.306-2.764.918-.636.613-.954 1.446-.954 2.5v2.242h-2.25v2.593h2.25V18H1.125c-.305 0-.568-.111-.791-.334A1.081 1.081 0 0 1 0 16.875V1.125C0 .82.111.557.334.334.557.111.82 0 1.125 0h15.75z"}})])
      }
    
      }
    